import { render, staticRenderFns } from "./ResourceEmpty.vue?vue&type=template&id=d03d7e58&scoped=true"
import script from "./ResourceEmpty.vue?vue&type=script&lang=js"
export * from "./ResourceEmpty.vue?vue&type=script&lang=js"
import style0 from "./ResourceEmpty.vue?vue&type=style&index=0&id=d03d7e58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d03d7e58",
  null
  
)

export default component.exports